import BgPng from "../../assets/background4.avif";

const backgroundStyle = {
  backgroundImage: `url(${BgPng})`,
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  height: "100%",
  width: "100%",
};
const AppStore = () => {
  return (
    <>
      <div className="py-14 relative z-50" style={backgroundStyle}>
        <div className="container">
          <div className="grid sm:grid-cols-2 grid-cols-1 items-center gap-4">
            <div
              data-aos="fade-up"
              data-aos-duration="300"
              className="space-y-6 max-w-xl mx-auto"
            >
              {/* text section */}
              <h1 className="text-xl text-center sm:text-left sm:text-3xl font-semibold text-white/90 pl-3">
                Ready to Transform Your Business?
              </h1>
              <p className="text-sm text-center sm:text-left sm:text-lg font-semibold text-white/90 pl-3">
                Let’s talk about how we can bring your digital vision to life.
              </p>
              {/* img section */}
              <div className="flex flex-wrap justify-center sm:justify-start items-center pl-5">
                <button className="primary-button">Get in Touch</button>
              </div>
            </div>
            {/* Empty div */}
            <div></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AppStore;
